var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCinemaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3333 0.333252L15 3.66659H12.5L10.8333 0.333252H9.16667L10.8333 3.66659H8.33333L6.66667 0.333252H5L6.66667 3.66659H4.16667L2.5 0.333252H1.66667C0.75 0.333252 0.00833333 1.08325 0.00833333 1.99992L0 11.9999C0 12.9166 0.75 13.6666 1.66667 13.6666H15C15.9167 13.6666 16.6667 12.9166 16.6667 11.9999V0.333252H13.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCinemaWhite);
export default __webpack_public_path__ + "static/media/cinema_white.c74ab6aa3974d800c62d85f6daac5f98.svg";
export { ForwardRef as ReactComponent };